import { ru } from "../../../../date-fns/locale/ru.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    ru
  }
};